import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Auth1 hosted login - uses the standard Auth1 UI
const AUTH1_LOGIN_URL = 'https://api.z101.ai/login/z101';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();

  const from = location.state?.from?.pathname || '/';

  // If already logged in, redirect to dashboard
  useEffect(() => {
    if (user && !loading) {
      navigate(from, { replace: true });
    }
  }, [user, loading, navigate, from]);

  // Redirect to Auth1 hosted login on mount (only if no token exists)
  useEffect(() => {
    if (!user && !loading) {
      // Don't redirect if there's already a token - the AuthContext is still loading
      const existingToken = localStorage.getItem('auth_token');
      if (existingToken) {
        return; // Token exists, wait for AuthContext to load user
      }
      const callbackUrl = window.location.origin + '/auth/callback';
      window.location.href = `${AUTH1_LOGIN_URL}?redirect_uri=${encodeURIComponent(callbackUrl)}`;
    }
  }, [user, loading]);

  // Show loading while redirecting
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#020617',
      color: '#f1f5f9'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(255,255,255,0.2)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }} />
        <div>Redirecting to login...</div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}

export default LoginPage;
